import { Typography, AppBar, Toolbar, Box, Container } from '@mui/material'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Paper } from '@e3dc-react/shell/Elements/Paper'

import ReactMarkdown from 'react-markdown'
import { reactMarkdownComponents } from './markdownConfig'

const useStyles = makeStyles()(theme => ({
  outerContainer: {
    border: `1px solid ${theme.palette.background.paperBorder}`,
    backgroundColor: theme.palette.background.paper,
    marginTop: theme.spacing(4),
    '&:after': {
      content: '""',
      background: theme.palette.background.application,
      position: 'fixed',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      zIndex: -1,
    },
  },
  toolbar: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.shape.header.borderRadius,
    color: theme.palette.text.header,
    background: theme.palette.background.header,
    alignItems: 'baseline',
    justifyContent: 'center',
    padding: theme.spacing(2),
  },
  title: {
    fontSize: theme.typography.h1.fontSize,
  },
  markdown: {
    paddingLeft: theme.spacing(4),
  },
}))

interface Props {
  markdownText: string
  siteTitle: string
  title: string
}

/**
 * This Component renders a markdown of our privacy protection statement
 */
const MarkdownWrapper: React.FC<Props> = ({ markdownText, siteTitle, title }) => {
  const { classes } = useStyles()

  return (
    <Container maxWidth="xl">
      <AppBar position="sticky" elevation={1}>
        <Toolbar className={classes.toolbar}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Typography variant="h2">{siteTitle}</Typography>
          </Box>
        </Toolbar>
      </AppBar>
      <Paper title={title} headlineClass={classes.title} className={classes.outerContainer}>
        <ReactMarkdown className={classes.markdown} components={reactMarkdownComponents}>
          {markdownText}
        </ReactMarkdown>
      </Paper>
    </Container>
  )
}

export default MarkdownWrapper
